var _a;
import { UnitSuffix } from '../../defs';
import { POINT_PIXEL_VALUE } from '../../internal/constants';
import { noConvert } from '../../internal/converters';
import { pixel } from '../../internal/converters/pixel';
var pointToPixel = function (value) {
    return value * POINT_PIXEL_VALUE;
};
var pointToCentimeter = function (value) {
    return pixel.cm(pointToPixel(value));
};
var pointToMillimeter = function (value) {
    return pixel.mm(pointToPixel(value));
};
var pointToQuarter = function (value) {
    return pixel.Q(pointToPixel(value));
};
var pointToInch = function (value) {
    return pixel.in(pointToPixel(value));
};
var pointToPica = function (value) {
    return pixel.pc(pointToPixel(value));
};
var pointToREM = function (value, options) {
    return pixel.rem(pointToPixel(value), options);
};
var pointToEM = function (value, options) {
    return pixel.em(pointToPixel(value), options);
};
var pointToViewWidth = function (value, options) {
    return pixel.vw(pointToPixel(value), options);
};
var pointToViewHeight = function (value, options) {
    return pixel.vh(pointToPixel(value), options);
};
var pointToViewMin = function (value, options) {
    return pixel.vmin(pointToPixel(value), options);
};
var pointToViewMax = function (value, options) {
    return pixel.vmax(pointToPixel(value), options);
};
export var point = (_a = {},
    _a[UnitSuffix.Pixel] = pointToPixel,
    _a[UnitSuffix.Centimeter] = pointToCentimeter,
    _a[UnitSuffix.Millimeter] = pointToMillimeter,
    _a[UnitSuffix.Quarter] = pointToQuarter,
    _a[UnitSuffix.Inch] = pointToInch,
    _a[UnitSuffix.Pica] = pointToPica,
    _a[UnitSuffix.Point] = noConvert,
    _a[UnitSuffix.REM] = pointToREM,
    _a[UnitSuffix.EM] = pointToEM,
    _a[UnitSuffix.ViewWidth] = pointToViewWidth,
    _a[UnitSuffix.ViewHeight] = pointToViewHeight,
    _a[UnitSuffix.ViewMin] = pointToViewMin,
    _a[UnitSuffix.ViewMax] = pointToViewMax,
    _a);
//# sourceMappingURL=point.js.map